/** Dedicated single-purpose copy of StockCountSchedule's "Count Zones" tab (Demo Mode nav
 * restructure) - same data/loading logic as the original tabbed page's tab three, rendered
 * as its own standalone screen instead of one of three tabs on a shared page. The original
 * tabbed page (index.tsx, route /stock-count-schedule/:tab) is untouched and remains the
 * production entry point. */

import { Box, Typography } from '@mui/material';
import CountZonesBox from './components/CountZonesBox';
import useNswagClient from '../../hooks/api/useNswagClient';
import { useContext, useEffect, useState } from 'react';
import { CountZonesResponse } from '../../app/services/api/generated';
import { UserContext } from '../../components/shared/useUser';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../components/shared/PageTitle';
import PageArea from '../../components/shared/PageArea';
import useLogError from '../../hooks/useLogError';

const CountZonesPage = () => {
  const { getCountZones } = useNswagClient();
  const { t } = useTranslation('common');
  const { selectedStore } = useContext(UserContext);
  const storeID = selectedStore?.storeNumber ? selectedStore.storeNumber : 'No store selected';
  const [zones, setZones] = useState<CountZonesResponse[]>([]);
  const [isZonesLoading, setIsZonesLoading] = useState(false);
  const { logError } = useLogError();

  useEffect(() => {
    loadZones();
  }, [selectedStore]);

  const loadZones = () => {
    setIsZonesLoading(true);
    getCountZones(storeID)
      .then((result) => {
        if (result?.data) setZones(result.data);
      })
      .catch(logError)
      .finally(() => setIsZonesLoading(false));
  };

  return (
    <Box sx={{ width: '100%', textAlign: 'left' }}>
      <PageArea>
        <PageTitle>{t('countZones', 'Count Zones')}</PageTitle>
        {selectedStore ? (
          <CountZonesBox zones={zones}
            storeID={storeID}
            loadData={loadZones}
            isLoading={isZonesLoading} />
        ) : (
          <Box><Typography variant='textLG'>No store selected</Typography></Box>
        )}
      </PageArea>
    </Box>
  );
};

export default CountZonesPage;
